const menuButton = document.querySelector('.mobile-menu');
const mobileDrawer = document.querySelector('.mobile-drawer');
if (menuButton && mobileDrawer) {
  menuButton.addEventListener('click', () => {
    const open = !mobileDrawer.hasAttribute('hidden');
    if (open) mobileDrawer.setAttribute('hidden',''); else mobileDrawer.removeAttribute('hidden');
  });
}
